import React from 'react';
import styled from 'styled-components';
import { Alert, AlertTitle, Button } from 'ceci-ui';
import DoneOutlineIcon from '@material-ui/icons/DoneOutline';

const StyledAlert = styled(Alert)``;

function ActivationAlert() {
  return (
    <StyledAlert
      icon={<DoneOutlineIcon />}
      severity="warning"
      style={{ marginTop: 30 }}
      action={
        <Button variant="outlined">
          Ativar conta
        </Button>
      }>

      <AlertTitle>Ative sua conta a qualquer momento. É grátis.</AlertTitle>
      Apenas com a conta ativada é possível enviar cobranças e receber pagamentos de seus clientes.
    </StyledAlert>
  );
}

export default ActivationAlert;
